import { createContext, useReducer, useEffect } from "react";
import axios from "axios";
import commonReducer from "./commonReducer";

const commonContext = createContext();

const initialState = {
  isFormOpen: false,
  formUserInfo: "",
  isSearchOpen: false,
  searchResults: [],
  productsData: [],
  productsLoading: false,
  productsError: null,
};

const CommonProvider = ({ children }) => {
  const [state, dispatch] = useReducer(commonReducer, initialState);

  // Actions for existing functionality
  const toggleForm = (toggle) => {
    return dispatch({
      type: "TOGGLE_FORM",
      payload: { toggle },
    });
  };

  const setFormUserInfo = (info) => {
    return dispatch({
      type: "SET_FORM_USER_INFO",
      payload: { info },
    });
  };

  const toggleSearch = (toggle) => {
    return dispatch({
      type: "TOGGLE_SEARCH",
      payload: { toggle },
    });
  };

  const setSearchResults = (results) => {
    return dispatch({
      type: "SET_SEARCH_RESULTS",
      payload: { results },
    });
  };

  // Fetch products
  const fetchProducts = async () => {
    dispatch({ type: "FETCH_PRODUCTS_START" });
    try {
      const response = await axios.get("https://fakestoreapi.com/products"); // Replace with your API URL
      const updatedData = response?.data?.map((item) => ({
        ...item, // Spread the existing keys
        quantity: 1, // Add the new key-value pair
      }));
      dispatch({
        type: "FETCH_PRODUCTS_SUCCESS",
        payload: updatedData,
      });
    } catch (error) {
      dispatch({
        type: "FETCH_PRODUCTS_FAILURE",
        payload: error.message,
      });
    }
  };

  const values = {
    ...state,
    toggleForm,
    setFormUserInfo,
    toggleSearch,
    setSearchResults,
    fetchProducts,
  };

  return (
    <commonContext.Provider value={values}>{children}</commonContext.Provider>
  );
};

export default commonContext;
export { CommonProvider };
